import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { CustomCategoryNavigationComponent } from './category-navigation.component';
import { CustomNavigationModule } from '../navigation/navigation.module';

@NgModule({
  imports: [CommonModule, CustomNavigationModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CategoryNavigationComponent: {
          component: CustomCategoryNavigationComponent,
          data: {
            resetMenuOnClose: true,
          },
        },
      },
    }),
  ],
  declarations: [CustomCategoryNavigationComponent],
  exports: [CustomCategoryNavigationComponent],
})
export class CustomCategoryNavigationModule {}
